import api from './client'

export const campaignsApi = {
  list: (showArchived = false) =>
    api.get('/api/campaigns', { params: { show_archived: showArchived } }),

  create: (data) => api.post('/api/campaigns', data),

  update: (id, data) => api.put(`/api/campaigns/${id}`, data),

  archive: (id) => api.post(`/api/campaigns/${id}/archive`),

  unarchive: (id) => api.post(`/api/campaigns/${id}/unarchive`),

  eligible: (id, limit = 50) =>
    api.get(`/api/campaigns/${id}/eligible`, { params: { limit } }),

  send: (id, prospectIds, testEmail = null) =>
    api.post(`/api/campaigns/${id}/send`, {
      prospect_ids: prospectIds,
      test_email: testEmail,
    }),

  pollSend: (id, jobId) =>
    api.get(`/api/campaigns/${id}/send/${jobId}`),

  getEmails: (id) => api.get(`/api/campaigns/${id}/emails`),
}